define('../app/fukit/behavior/hide.when.collection.empty.behavior',['require','exports','module','uikit/uikit'],function(require, exports, module) {
  var UIKit = require('uikit/uikit');
  module.exports = UIKit.HideWhenCollectionEmptyBehavior;
});

